import React, { useEffect, useState } from "react";
import { useNavigate , useParams} from 'react-router-dom'
import "./CourseDropdown.css"

function CourseDropdown({ courses, defaultValue, identy }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState("Select Course");
  
  const { courseParam,difficulty } = useParams();
  const navigator = useNavigate();
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };



  const handleSelectCourse = (course) => {
    setSelectedCourse(course);
    toggleDropdown();
    if (identy === "courseDrop") { 
      navigator(`/categories/${course.toLowerCase()}/${difficulty && difficulty}`);
    } else {
      navigator(`/categories/${courseParam}/${course.toLowerCase()}`);
    }
  };
  
  useEffect(() => {
    setSelectedCourse(defaultValue)
  },[defaultValue]);
  


  return (
    <div className="maindropdown h-[50px] relative border-t border-gray-800 bg-gray-950 w-full">
      <div className="p-1 w-full">
        <button
          onClick={toggleDropdown}
          className="w-full flex items-center justify-between p-2 rounded border border-gray-950 focus:outline-none focus:border-blue-950 uppercase"
        >
          <span>{selectedCourse}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`h-5 w-5 transition-transform duration-300 transform ${
              isOpen ? "rotate-180" : ""
            }`}
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M6.293 8.293a1 1 0 011.414 0L10 10.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414zM10 4a1 1 0 100 2 1 1 0 000-2z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>
      {isOpen && (
        <div className="absolute top-full max-h-[50vh]  overflow-auto left-0 z-10  w-full bg-gray-950  shadow-lg">
          {courses.map((item, index) => (
            <ul className="py-0.5 " key={index}>
              <li
                className="z-auto px-4 py-2 w-[95%] rounded   m-auto  cursor-pointer uppercase hover:bg-gray-800"
                onClick={() => handleSelectCourse(item)}
              >
                {item}
              </li>
            </ul>
          ))}
        </div>
      )}
    </div>
  );
}

export default CourseDropdown;
